import { useState } from "react";
import { Typography, Button, } from "@mui/material";

const Status = ({ close, unenroll }) => {

  return (
    <div
      style={{
        height: "100vh",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Typography variant="h5" align="center">
            You Are Registered!
          </Typography>
          <Typography>
            If you haven't already, please fill out your Skill Swap profile. You
            can find it in your Event Profiles if you close this Dialog. We send
            out matches every day before 8PM. If you have any questions you can
            always email us at{" "}
            <a href="mailto:info@thenextfunthing.com">
              info@thenextfunthing.com
            </a>
          </Typography>
          <Typography>
            Want to unenroll? No problem. Just click the button below and you
            will be immediately removed from the Skill Swap event. You will no
            longer be able to edit your Skill Swap profile and all of your
            matches will be deleted. You will no longer recieve any match
            emails.
          </Typography>
          <Typography></Typography>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
       
        <Button variant="contained" onClick={unenroll}>
          Unenroll
        </Button>
        <Button variant="outlined" onClick={close}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default Status;
